/**
 * Formats a phone number string for human-readable display as (NXX) NXX-XXXX.
 *
 * Accepts any format (raw digits, formatted, with hyphens, etc.) and normalises
 * to a consistent 10-digit US display format. Returns the input unchanged if it
 * does not contain exactly 10 digits after stripping non-numeric characters.
 */
function formatPhoneDisplay(phone: string): string {
  const digits = phone.replace(/\D/g, "").slice(0, 10);

  if (digits.length !== 10) {
    return phone;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export { formatPhoneDisplay };
